<template>
  <div class="container">
    <div class="box">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/member-center' }">个人中心</el-breadcrumb-item>
        <el-breadcrumb-item>个人信息</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content_box">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="个人资料" name="first">


            <div v-show="phoneshow == false">
              <el-form :model="userFormData" :label-position="labelPosition" label-width="80px" :rules="info_rules" ref="infoForm">
                
                <el-form-item label="头像" prop="user_avatar" >
                  <imageUpload v-model="userFormData.user_avatar" />
                </el-form-item>
                <el-form-item label="昵称" prop="alias_name" >
                  <el-input v-model="userFormData.alias_name" placeholder="昵称" style="width: 300px"/>
                </el-form-item>
                <el-form-item label="手机号" prop="mobile" >
                  {{ userFormData.mobile }}
                  <span style="color: blue" @click="changephone">更换手机号</span>
                </el-form-item>
                <el-form-item label="性别" prop="sex" >
                  <el-radio-group v-model="userFormData.sex">
                    <el-radio :label="1">男</el-radio>
                    <el-radio :label="2">女</el-radio>
                    <el-radio :label="0">不公开</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="年龄" prop="age" >
                  <el-input v-model="userFormData.age" placeholder="年龄" style="width: 300px"/>
                </el-form-item>

                <el-form-item label="签名" prop="description" >
                  <el-input v-model="userFormData.description" placeholder="签名" type="textarea" style="width: 300px"/>
                </el-form-item>
                <el-form-item >
                  <el-button type="primary" @click="confirm">保存</el-button>
                </el-form-item>
              </el-form>
            </div>

            <div v-show="phoneshow == true">
              <div class="content">
                 <el-form :model="forms" :label-position="labelPosition" label-width="80px" :rules="phone_rules" ref="ruleForms">
                      <el-form-item label="原手机号">
                        <el-input style="width: 300px" v-model="userFormData.mobile" disabled></el-input>
                      </el-form-item>
                      <el-form-item type="number" label="验证码" prop="code1">
                        <el-input style="width: 200px" v-model="forms.code1" placeholder="请输入验证码"></el-input>
                        <el-button type="primary" @click="getcodes"   v-if="codeShows" style="margin-left: 10px">获取验证码</el-button>

                        <span v-if="!codeShows" style=" color: #4c71db;font-size: 12px; padding-left: 10px;">{{ count2 }}秒后重试</span>
                      </el-form-item>
                      <el-form-item label="新手机号" prop="phone2">
                        <el-input style="width: 300px" v-model="forms.phone2" placeholder="请输入手机号"></el-input>
                      </el-form-item>
                      <el-form-item type="number" label="验证码" prop="code2">
                        <el-input style="width: 200px" v-model="forms.code2" placeholder="  请输入验证码"></el-input>
                        <el-button type="primary" @click="getcodess"   v-if="codeShowss" style="margin-left: 10px">获取验证码</el-button>

                        <span v-if="!codeShowss" 
                        style="
                            color: #4c71db;
                            font-size: 12px;
                            padding-left: 10px;
                          ">{{ count3 }}秒后重试</span>
                      </el-form-item>

                      <el-form-item >
                        <el-button type="primary" @click="submitPhone('ruleForms')">保存</el-button>
                        <el-button type="normal" @click="phoneshow = false">取消</el-button>
                      </el-form-item>
                  </el-form>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="账号安全" name="second">
            <div class="content">
              <div class="content_child">
                <p style="margin-bottom: 20px">修改密码</p>
                  <el-form :model="form" :label-position="labelPosition" label-width="80px" :rules="pwd_rules" ref="pwdForm">
                    <el-form-item label="手机号" prop="phone">
                      <el-input style="width: 300px" v-model="form.phone" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                    <el-form-item type="number" label="验证码" prop="code">
                      <el-input style="width: 200px" v-model="form.code" placeholder=" 请输入验证码"></el-input>
                      <el-button type="primary" @click="getcode" style="margin-left: 10px" v-if="codeShow">获取验证码</el-button>
                      <span v-if="!codeShow" 
                      style="
                          color: #4c71db;
                          font-size: 12px;
                          padding-left: 10px;
                        ">{{ count }}秒后重试</span>
                    </el-form-item>
                    <el-form-item label="新密码" prop="pwd">
                      <el-input style="width: 300px" type="password" v-model="form.pwd" placeholder="  请输入六到十六位密码"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="password">
                      <el-input style="width: 300px" type="password" v-model="form.password" placeholder="  请再次输入"></el-input>
                    </el-form-item>

                    <el-form-item >
                        <el-button type="primary" @click="submitPwd('pwdForm')">保存</el-button>
                      </el-form-item>


                  </el-form>

                
              </div>
            </div>
          </el-tab-pane>

        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import ImageUpload from '@/components/ImageUpload';

import {
  userinfo,
  userstore,
  syatempassword,
  mobileupdate,
} from "@/api/apply/index";
import { mobilesms } from "@/api/login/login";
export default {
  components: {
    ImageUpload
  },

  data () {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.form.password !== "") {
          this.$refs.ruleForm.validateField("password");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.pwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      activeName: "first",
      userFormData:{},
      phoneshow: false,
      codeShow: true,//修改密码
      codeShows: true,//更换手机号
      codeShowss: true,//更换新手机号
      count: 0,
      count2: 0,
      count3: 0,
      labelPosition: "right",
      form: {
        phone: "",
        code: "",
        pwd: "",
        password: "",
      },
      forms: {
        phone1: "",
        code1: "",
        phone2: "",
        code2: "",
      },
      info_rules:{

      },
      pwd_rules: {
        code: [
          { required: true, message: "请输入验证码", trigger: "change" },
          {
            pattern: /^[0-9]*$/,
            message: "只能是数字",
            trigger: "blur",
          },
        ],
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            pattern:
              /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/,
            message: "手机号码格式不对，请重新输入",
            trigger: "blur",
          },
        ],
        pwd: [
          { required: true, validator: validatePass, trigger: "change" },
          {
            min: 6,
            max: 16,
            message: "长度在 6 到 16 个字符",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, validator: validatePass2, trigger: "change" },
        ],
      },
      phone_rules: {
        code1: [
          { required: true, message: "请输入验证码", trigger: "change" },
          {
            pattern: /^[0-9]*$/,
            message: "只能是数字",
            trigger: "blur",
          },
        ],
        phone1: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            pattern:
              /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/,
            message: "手机号码格式不对，请重新输入",
            trigger: "blur",
          },
        ],
        code2: [
          { required: true, message: "请输入验证码", trigger: "change" },
          {
            pattern: /^[0-9]*$/,
            message: "只能是数字",
            trigger: "blur",
          },
        ],
        phone2: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            pattern:
              /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/,
            message: "手机号码格式不对，请重新输入",
            trigger: "blur",
          },
        ],
      },
     
    };
  },

  created () {
    this.getUserInfo();
  },
  mounted () { },
  methods: {
    //更换手机号
    changephone () {
      this.phoneshow = true;
    },
    //获取验证码
    getcode () {
      let reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
      if (reg.test(this.form.phone) == false) {
        this.$message({
          type: "warning",
          message: "手机号格式有误",
        });
        return;
      }
      let data = {
        mobile: this.form.phone,
        mobile_type: 6,
      };
      mobilesms(data).then((res) => {
        if (res.code == 200) {
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.codeShow = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.codeShow = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
          this.$message({
            type: "success",
            message: res.msg,
          });
        } else {
          this.$message({
            type: "warning",
            message: res.data.message,
          });
        }
      });
    },
    //获取验证码
    getcodes () {
      let data = {
        mobile: this.userFormData.mobile,
        mobile_type: 13,
      };
      mobilesms(data).then((res) => {
        if (res.code == 200) {
          const TIME_COUNT = 60;
          if (!this.timers) {
            this.count2 = TIME_COUNT;
            this.codeShows = false;
            this.timers = setInterval(() => {
              if (this.count2 > 0 && this.count2 <= TIME_COUNT) {
                this.count2--;
              } else {
                this.codeShows = true;
                clearInterval(this.timers);
                this.timers = null;
              }
            }, 1000);
          }
          this.$message({
            type: "success",
            message: res.msg,
          });
        } else {
          this.$message({
            type: "warning",
            message: res.data.message,
          });
        }
      });
    },
    //获取验证码
    getcodess () {
      let reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
      if (reg.test(this.forms.phone2) == false) {
        this.$message({
          type: "warning",
          message: "手机号格式有误",
        });
        return;
      }
      let data = {
        mobile: this.forms.phone2,
        mobile_type: 13,
      };
      mobilesms(data).then((res) => {
        if (res.code == 200) {
          const TIME_COUNT = 60;
          if (!this.timerss) {
            this.count3 = TIME_COUNT;
            this.codeShowss = false;
            this.timerss = setInterval(() => {
              if (this.count3 > 0 && this.count3 <= TIME_COUNT) {
                this.count3--;
              } else {
                this.codeShowss = true;
                clearInterval(this.timerss);
                this.timerss = null;
              }
            }, 1000);
          }
          this.$message({
            type: "success",
            message: res.msg,
          });
        } else {
          this.$message({
            type: "warning",
            message: res.data.message,
          });
        }
      });
    },

    submitPwd (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            mobile: this.form.phone,
            mobile_code: this.form.code,
            password: this.form.pwd,
            newpassword: this.form.password,
          };
          syatempassword(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "设置成功",
              });
              this.form = {};
            }
            if (res.data.code == 406) {
              this.$message({
                type: "error",
                message: "验证码不正确",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //确认更换手机号
    submitPhone (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            mobile: this.userFormData.mobile,
            mobile_code: this.forms.code1,
            newmobile: this.forms.phone2,
            newmobile_code: this.forms.code2,
          };
          mobileupdate(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "设置成功",
              });
              this.forms = {};
              this.phoneshow = false
              this.getUserInfo()
            } else {
              this.$message({
                type: "warning",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
 
    //保存修改
    confirm () {
      userstore(this.userFormData).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "保存成功",
          });
          this.getUserInfo();
        } else {
          this.$message({
            type: "warning",
            message: res.msg,
          });
        }
      });
    },
    getUserInfo () {
      userinfo().then((res) => {
        this.userFormData = (res && res.data) ? res.data : {};
      }).catch(() => {
        this.userFormData = {};
      });
    },
    handleClick (e, event) {
      console.log(e.index);
    },
  },
};
</script>

<style lang='scss' scoped>
::v-deep .main_box{
  background-color: rgb(240, 237, 241) !important;
}

::v-deep .el-upload--picture-card{
  border-radius:50% !important;

  .el-image{
    border-radius:50% !important;

  }
}
.box {
  width: 1200px;
  margin: auto;
  .content_box {
    margin: 20px 0;
    background-color: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0px 0px 13px rgba(0, 0,0, 0.15);
    .first_box {
      margin-top: 30px;
      display: flex;
      flex-direction: column;
      width: 200px;
      align-items: center;
      img {
        border-radius: 50%;
        width: 80px;
        height: 80px;
      }
    }
    .first_boxchild {
      display: flex;
      align-items: center;
      margin: 40px 0;
    }
    .btn {
      margin-left: 80px;
      width: 100px;
      height: 35px;
      color: white;
      border-radius: 6px;
      background-color: #4c71db;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .content {
      .content_child {
        height: 80%;
        border-radius: 8px;
        background-color: white;
        .updatebtn {
          width: 120px;
          height: 40px;
          background-color: #4c71db;
          border-radius: 7px;
          color: white;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 0.9rem;
          margin-left: 100px;
          margin-top: 50px;
        }
        .btns {
          padding: 10px 10px;
          background-color: #4c71db;
          border-radius: 7px;
          color: white;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
